/**
 * Import JavaScript Assets
 */
import { loadingGif } from "commonAssets/js/helpers";
import { loading, appDocketAPI, appClaimForm } from "commonAssets/js/constants";
// import { Cookies, Footer, Header, ImportantDates, Navigation, Page, ErrorHandler } from "commonAssets/js/classes";
import { Cookies, Page, ErrorHandler } from "commonAssets/js/classes";
import { Header } from "commonAssets/components/Header";
import { Navigation } from "commonAssets/components/Navigation";
import { Footer } from "commonAssets/components/Footer";
import { ImportantDates } from "commonAssets/components/ImportantDates";
import { siteTitle } from "commonAssets/js/helpers";
import { OptOut, SubmitClaim } from "commonAssets/js/submit-claim";
import { I18n } from 'commonAssets/i18n';
import languages from './languages';
import {
    siteInfoLang,
    userLanguage,
    setSiteInfo,
    setSiteInfoLang,
    setEmailInform,
    setPhoneAdmin,
    setEmailConfirm,
    setUserLanguage,
    setAppLocale,
    setI18n
} from "../../common/assets/js/constants";
import { customPage, customSubmitClaim, customInit, customProcess, customImptDates, consumerClaimPagePixel, thirdParyClaimPagePixel, makeStandardContactPage } from "./scripts/custom";
import { createElement } from "../../common/assets/js/helpers";
// import { foo, bar } from "./scripts/custom";

/**
 * Import Custom JavaScript Script
 */
// import { customClassExample } from "./scripts/custom";

/**
 * Internationalization (i18n) Handling
 * 
 * Sets the langauges available for the distribution.
 * 
 * Examples:
 * i18n.languages returns languages in an array
 * i18n.userLanguage returns current languages
 * i18n.getTranslation('string') returns predefined string
 */
const i18n = I18n.create(['en', 'es'], {}, languages);
setI18n(() => i18n);

/**
 * Cookies
 * @returns {void}
 */
const set_cookies = new Cookies();
set_cookies.init();

/**
 * Set the user's language using the value from `set_cookies.language()`.
 * @param {Function} setCookiesLanguage - The function that returns the user's language.
 */
setUserLanguage(() => set_cookies.language());

/**
 * Set the application locale using the value from `set_cookies.locale()`.
 * @param {Function} setCookiesLocale - The function that returns the application locale.
 */
setAppLocale(() => set_cookies.locale());

/**
 * Loading GIF
 */
loadingGif(loading, "show");

/**
 * Initialize the analytics by loading the Google Tag Manager script and 
 * configuring the dataLayer and gtag. 
 */
export function analytics() {
    $.getScript("https://www.googletagmanager.com/gtag/js?id=G-LGF2TN8VN9", () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());

        gtag('config', 'G-WKXC7VDFFT'); // swatjs
        gtag('config', 'G-LGF2TN8VN9'); // general

        gtag('config', 'G-283TXTJDG7'); // Novartis
        gtag('config', 'G-E1M4HEY8P9'); // jsb
        gtag('config', 'AW-10858394745'); // sem
    });

    // jsb
    $.getScript("https://js.adsrvr.org/up_loader.1.1.0.js", () => {
        ttd_dom_ready(function () {
            if (typeof TTDUniversalPixelApi === 'function') {
                var universalPixelApi = new TTDUniversalPixelApi();
                universalPixelApi.init("45mfygg", ["b9ifqd9"], "https://insight.adsrvr.org/track/up");
            }
        });
    });

    // pixels
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '173618391590419');
    fbq('track', 'PageView');
}

/**
 * Calls the appropriate function to display page content based on the given domainSlug.
 * If domainSlug is empty, the 'home' case will be executed.
 *
 * @param {Array} sitePages - An array containing the website sitePages' information.
 * @param {string} domainSlug - The unique identifier (slug) of the page to be displayed.
 * @param {} importantDates -
 *
 * @example
 * // Assuming sitePages array and domainSlug are defined and valid
 * getPage(sitePages, domainSlug, importantDates);
 */
export function getPage(sitePages, domainSlug, importantDates) {

    loadingGif(loading, "show");
    // Set domainSlug to 'home' if empty
    (domainSlug === '') ? siteTitle(sitePages) : siteTitle(sitePages, domainSlug);

    // Misc handling.
    domainSlug = domainSlug || 'home';
    const page = new customPage(sitePages, domainSlug, importantDates);

    switch (domainSlug) {

        case 'home':
            page.home();
            analytics();
            break;

        case 'submit-claim':
            // forward to fix-claim
            window.location.href = '/fix-claim';
            break;

        case 'fix-claim':
            // Generic page to handle the two links to the claim forms.
            // page.claimPage();
            // analytics();
            const _fix = new customSubmitClaim(appClaimForm, userLanguage, customInit, customProcess, 'claim-form-3rd-party');
            _fix.form();
            thirdParyClaimPagePixel();
            analytics();
            break;

        case 'claim-form-consumer':
            // const consumer = new customSubmitClaim(appClaimForm, userLanguage, customInit, customProcess, 'claim-form-consumer');
            // consumer.form();
            // consumerClaimPagePixel();
            window.location.href = '/fix-claim';
            analytics();
            break;

        case 'claim-form-3rd-party':
            const third_party = new customSubmitClaim(appClaimForm, userLanguage, customInit, customProcess, 'claim-form-3rd-party');
            third_party.form();
            thirdParyClaimPagePixel();
            // window.location.href = '/fix-claim';
            analytics();
            break;

        case 'important-documents':
            page.important_documents();
            analytics();
            break;

        case 'faqs':
            page.faqs();
            analytics();
            break;

        case 'contact-us':
            // page.contact(makeStandardContactPage, userLanguage);
            page.contact();
            analytics();
            break;

        default:
            page.error();
            analytics();
    }
}

/**
 * Fetches domain API data and updates the website with the retrieved data.
 * Updates site title, site name, case number, court name, and builds navigation
 * based on the fetched data. Also adds event listener for hash changes to
 * update page content accordingly.
 *
 * @example
 * // Assuming that appDocketAPI and appLang are defined and valid
 * fetch(appDocketAPI)
 * .then(response => response.json())
 * .then(data => { ... })
 * .catch(error => console.error(error));
 */

fetch(appDocketAPI)
    .then(response => {
        if (response.status > 299) {
            // Hide loading gif
            loadingGif(loading, "hide", 1000);
            // Display error message
            const error = new ErrorHandler();
            error.display(response);
        }
        return response.json()
    })
    .then(data => {
        setSiteInfoLang(() => data.findResult.lang[userLanguage]);
        setSiteInfo(() => data.findResult);
        setEmailInform(() => data.findResult.email_info);
        setPhoneAdmin(() => data.findResult.phone);
        setEmailConfirm(() => data.findResult.email_conf);

        document.title = siteInfoLang.SiteTitle;

        // Returns the first value after FQDN. Example: fqdn.com/THIS/foo/bar
        let domainSlug = window.location.pathname.split("/")[1];

        let sitePages = siteInfoLang.Pages;
        sitePages.forEach((page) => {
            if (page.PageTitle === 'Submit Claim') {
                page.PageTitle = 'Fix Claim';
                page.PageName = 'fix-claim';
            }
        });

        const header = new Header(siteInfoLang.SiteName, siteInfoLang.CaseNumber, siteInfoLang.CourtName);
        const navigation = new Navigation(sitePages, domainSlug, getPage);
        const footer = new Footer();
        const importantDates = new customImptDates(data);

        const headerElem = document.querySelector('header');
        headerElem.classList.add("py-3");
        headerElem.appendChild(header.createHeader());

        navigation.pathChange(sitePages, domainSlug, importantDates);

        document.querySelector("header").insertAdjacentHTML('afterend', navigation.element.outerHTML);
        document.querySelector("footer").appendChild(footer.element);

        getPage(sitePages, domainSlug, importantDates);
    })
    .catch(error => console.error(error));